"use client";

import { Close } from "@mui/icons-material";
import { Box, Button, Chip, Grow, IconButton, LinearProgress, Stack, SwipeableDrawer, Typography } from "@mui/material";
import { useState } from "react";
import { toggleBrandId } from "./brandFilterSchema";
import SearchFiltersBrandsSelect from "./SearchFiltersBrandsSelect";
import { useSiteSearchContext } from "./SiteSearchContext";

function BrandsList({ handleClose }: { handleClose: () => void }) {
  const { brands, selectedBrands, handleBrandsChange } = useSiteSearchContext();
  const [selected, setSelected] = useState<number[] | undefined>(selectedBrands);
  const hasSelectedBrands = Boolean(selectedBrands && selectedBrands.length > 0);

  return (
    <>
      <Box sx={{ display: "flex", px: 2, pb: 2, overflowY: "auto", flexGrow: 1, alignItems: "start" }}>
        <Box sx={{ width: "100%" }}>
          <SearchFiltersBrandsSelect
            brands={brands}
            values={selected}
            onToggle={(id) => {
              setSelected((current) => toggleBrandId(current, id));
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: hasSelectedBrands ? "space-between" : "end",
          gap: 1,
          p: 2,
        }}
      >
        {hasSelectedBrands && (
          <Button
            variant="outlined"
            onClick={() => {
              handleBrandsChange(undefined);
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
            startIcon={<Close />}
          >
            حذف فیلتر
          </Button>
        )}
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "end", gap: 1 }}>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleBrandsChange(selected);
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
          >
            اعمال فیلتر
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default function MobileFilterBrandChip() {
  const { isPending, brands, selectedBrands, handleBrandsChange } = useSiteSearchContext();
  const [open, setOpen] = useState(false);
  const hasSelectedBrands = Boolean(selectedBrands && selectedBrands.length > 0);

  if (!brands || brands.length === 0) {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Chip
        variant={hasSelectedBrands ? "filled" : "outlined"}
        onClick={() => {
          setOpen(true);
        }}
        {...(hasSelectedBrands && {
          color: "primary" as const,
          onDelete: () => {
            handleBrandsChange(undefined);
          },
        })}
        label={<Typography variant="body2">برند{hasSelectedBrands ? ` (${selectedBrands?.length})` : ""}</Typography>}
      />

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: "70vh",
            borderTopLeftRadius: 4 * 4,
            borderTopRightRadius: 4 * 4,
          },
        }}
        anchor="bottom"
        open={open}
        onClose={handleClose}
        onOpen={() => {}}
        disableDiscovery
        hysteresis={0}
        disableSwipeToOpen
        swipeAreaWidth={0}
      >
        <Stack sx={{ height: "100%", flexGrow: 1 }}>
          <Stack sx={{ flexShrink: 0 }}>
            <Grow in={isPending}>
              <LinearProgress variant="indeterminate" color="secondary" />
            </Grow>
          </Stack>
          <Stack direction="row" sx={{ mt: 1, flexShrink: 0 }} alignItems="center" justifyContent="center">
            <Box width="45px" height="5px" sx={{ borderRadius: 50, backgroundColor: "grey.100" }} />
          </Stack>
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4">فیلتر برند</Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <BrandsList handleClose={handleClose} />
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
